import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;
`;

export const Body = styled.div<{ $noBreakpoints: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: row;

  min-height: 0;

  ${({ theme, $noBreakpoints }) =>
    !$noBreakpoints &&
    css`
      overflow: auto;
      flex-direction: column;

      ${theme.breakpoints.up(theme.breakpoints.values.sm)} {
        flex-direction: row;
        overflow: initial;
      }
    `};
`;

export const Main = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  min-width: 0;
`;

export const MainBody = styled.div<{ $paddingTop?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};

  padding: ${({ theme, $paddingTop }) =>
    `${$paddingTop ? theme.spacing(4) : 0} ${theme.spacing(6)} 0 ${theme.spacing(4.5)}`};
  min-height: 0;

  overflow: auto;
`;

export const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};

  padding: ${({ theme }) => `0 0 ${theme.spacing(2)}`};
`;

export const DescriptionContainer = styled.div`
  padding: ${({ theme }) =>
    `${theme.spacing(1)} 0 ${theme.spacing(1)} ${theme.spacing(6.5)}`};
`;

export const SubTaskListContainer = styled.div`
  padding: ${({ theme }) => `0 0 0 ${theme.spacing(4.25)}`};
`;

export const SidePanel = styled.div<{
  $wide?: boolean;
  $noBreakpoints: boolean;
}>`
  width: ${({ $wide }) => ($wide ? '29.6rem' : '25.6rem')};

  background: ${({ theme }) => theme.palette.background.paper};
  border-left: ${({ theme }) => `1px solid ${theme.palette.divider}`};

  ${({ theme, $wide, $noBreakpoints }) =>
    !$noBreakpoints &&
    css`
      width: 100%;

      ${theme.breakpoints.up(theme.breakpoints.values.sm)} {
        width: ${$wide ? '29.6rem' : '25.6rem'};
      }
    `};
`;
